module.exports = __webpack_public_path__ + "img/md-phone-landscape.dd0357e5.svg";